import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 20px 0;
    text-align: start;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 100%;
    }
  `};
`;

export const TitleContainer = styled.div`
  align-self: start;
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.lg};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0;
  `};
`;

export const Subtitle = styled.h2`
  ${({ theme }) => css`
    align-self: start;
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 16px 0;
  `};
`;

export const OptionsWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style-type: none;
  margin: 24px 0px 0px 0px;
  max-width: 685px;
  padding: 0px;
`;

export const ListItem = styled.li``;

export const RadioLabel = styled.label`
  ${({ theme, $checked }) => css`
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 26px;

    ${!$checked && css`
      border: 1px solid ${theme.v2.colors.neutral.highMedium};
    `}
    ${$checked && css`
      border: 2px solid ${theme.v2.colors.brand.primaryMedium};
    `}
  `}
`;

export const OptionRow = styled.span`
  ${() => css`
    display: flex;
    flex-direction: row;
    align-item: center;
    justify-content: flex-start;

    > button {
      padding: 0px;
    }
  `}
`;

export const OptionTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px 0px 0px 24px;
  `};
`;

export const OptionDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px 0px 0px 59px;
    text-align: left;
  `};
`;
